var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1079_4891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.942 19H18.7561C18.5365 19 18.3498 18.8244 18.3498 18.594V15.4781L16.2745 16.7727C16.0988 16.8824 15.8792 16.8824 15.7035 16.7727L13.6392 15.4781V18.594C13.6392 18.8135 13.4635 19 13.2329 19H12.058C11.8384 19 11.6518 18.8244 11.6518 18.594V12.5815C11.6518 12.2853 11.8933 12.0439 12.1898 12.0439C12.2996 12.0439 12.3984 12.0768 12.4863 12.1426L15.7584 14.3918C15.8902 14.4906 16.0769 14.4906 16.2086 14.3918L19.4808 12.1426C19.7224 11.9781 20.0627 12.0439 20.2275 12.2853C20.2933 12.373 20.3153 12.4828 20.3263 12.5815V18.594C20.3373 18.8135 20.1616 19 19.942 19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88392 18.989H2.52706C2.23059 18.989 1.98902 18.7476 1.98902 18.4514V12.406C2 12.1755 2.17569 12 2.40627 12H3.59216C3.81176 12 3.99843 12.1755 3.99843 12.406V17.0031H8.45647V12.406C8.45647 12.1865 8.63216 12 8.86274 12H10.0157C10.2353 12 10.422 12.1755 10.422 12.406V18.4514C10.422 18.7476 10.1804 18.989 9.88392 18.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1161 12H29.4729C29.7694 12 30.011 12.2414 30.011 12.5376V18.5831C30.011 18.8025 29.8353 18.989 29.6157 18.989H28.4298C28.2102 18.989 28.0235 18.8135 28.0235 18.5831V14.2492C28.0235 14.1066 27.9027 13.9859 27.76 13.9859H23.84C23.6973 13.9859 23.5765 14.1066 23.5765 14.2492V18.5831C23.5765 18.8025 23.4008 18.989 23.1702 18.989H21.9843C21.7647 18.989 21.578 18.8135 21.578 18.5831V12.5376C21.578 12.2414 21.8196 12 22.1161 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2016 15.2586H26.3765C26.5961 15.2586 26.7827 15.4342 26.7827 15.6646V16.8605C26.7827 17.0799 26.6071 17.2664 26.3765 17.2664H25.2016C24.982 17.2664 24.7953 17.0909 24.7953 16.8605V15.6536C24.7953 15.4342 24.982 15.2586 25.2016 15.2586Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1079_4891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 7,
    fill: "white",
    transform: "translate(2 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUma);
export default __webpack_public_path__ + "static/media/UMA.1e4006d7e0c5884616a2ded5390f706d.svg";
export { ForwardRef as ReactComponent };